export enum ClientEnum {
  ID = '4bFF8NMwH3SiHNza7',
  SECRET = 'zF_mDL0oZbsolRUoPOSj'
}
